var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUnableFile48Line = function SvgIconUnableFile48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 13.7v3.1c0 1.6 1.3 2.9 2.9 2.9h3.1v6.2l3.4 3.4V18c0-.11-.01-.22-.03-.33-.03-.15-.08-.28-.15-.41-.02-.03-.03-.07-.05-.1-.07-.13-.16-.25-.27-.36l-6-6c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.03-.09-.05-.23-.11-.48-.18-.75-.18H17.6c-.28 0-.55.04-.81.08l3.32 3.32h6.2-.01ZM11.2 8.8l-2.4 2.4 3.58 3.58c-.04.27-.08.54-.08.82v16.8c0 2.92 2.38 5.3 5.3 5.3h12.8c1.36 0 2.58-.53 3.52-1.38l2.88 2.88 2.4-2.4-28-28Zm19.2 25.5H17.6a1.9 1.9 0 0 1-1.9-1.9V18.1l15.82 15.82c-.32.23-.7.37-1.12.37v.01Z",
    fill: "current"
  })));
};
export default SvgIconUnableFile48Line;